export const FRIENDS_COUNTER_DATA_TEST_ID = 'FriendsCounter'
